import { render, staticRenderFns } from "./CustomerPaymentMethods.vue?vue&type=template&id=173b3370"
import script from "./CustomerPaymentMethods.vue?vue&type=script&lang=js"
export * from "./CustomerPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports